declare var loadDrilldown: Function;
class ReportTemplate {
    id: number;
    name: string;
    externalId: number;
    parentItemId: number;
    order: number;
    config: ReportConfig; //BaseItemConfig

    get visibility() {
        return this.config.visibility() === VisibilityEnum.Normal;
    }
    set visibility(value: boolean) {
        this.config.visibility(value ? VisibilityEnum.Normal : VisibilityEnum.Deprecated);
    }

    get aggregate() {
        return this.config.isAggregative();
    }
    set aggregate(value: boolean) {
        this.config.isAggregative(value);
    }

    get fieldsMetricsConcat() {
        let fields = this.config.fields().map(x => x.displayNameForDesigner());
        let metrics = this.config.metricFields().map(x => x.displayNameForDesigner());

        if (this.config.includeAllMetrics()) {
            metrics = ["All metrics"];
        }

        return fields.concat(metrics).join(', ');
    }

    constructor(data, isOriginalTemplate: boolean = false) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
        this.externalId = data?.externalId ?? 0;
        this.parentItemId = data?.parentItemId ?? 0;
        this.order = data?.order ?? 0;
        this.config = new ReportConfig(data?.config ?? {}, isOriginalTemplate);
    }

    save(mappingId: number, sucessCallback: (data: any, e: Event) => void = null) {
        let self = this;
        let model = {
            isNew: this.id <= 0,
            reportTemplate: {
                mappingId: mappingId,
                id: this.id,
                name: this.name,
                config: irGlobal.jsonStringfy(ko.toJS(this.config)),
                order: this.order
            }
        };

        let o = {
            url: `${urlConfigs.reportTemplate}Save`,
            data: model,
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            if (data.success) {
                let mapping = MappingService.getMapping(mappingId);

                if (model.isNew) {                    
                    self.id = data.id;
                    self.externalId = data.externalId;
                    self.config.updateAfterReportDesigner(new ReportConfig(data.config, true));
                }

                let childReportsToRemove = mapping.originalReports.filter(x => x.parentItemId === self.id);
                for (let childReport of data.childReports) {
                    let child = mapping.getOriginalReport(childReport.id);
                    if (child) {
                        child.name = childReport.name;
                        child.config.updateAfterReportDesigner(new ReportConfig(childReport.config, true));

                        childReportsToRemove = childReportsToRemove.filter(x => x.id !== child.id);
                    }
                    else {
                        child = new ReportTemplate(childReport, true);
                        mapping.addOriginalReport(child);
                    }
                }

                for (let childReport of childReportsToRemove) {
                    mapping.removeOriginalReportById(childReport.id);
                }
            }
            else {
                irGlobal.defaultErrorFunction("Failed to save report template", data.message, "");
            }

            if (sucessCallback) {
                sucessCallback(data, e);
            }

            if (loadDrilldown) {
                loadDrilldown();
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to save report template";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    delete(mappingId: number, sucessCallback: (data: any, e: Event) => void = null) {
        let o = {
            url: `${urlConfigs.reportTemplate}Delete`,
            data: { id: this.id, mappingId: mappingId },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            if (data.success) {
                let mapping = MappingService.getMapping(mappingId);
                for (let reportId of data.deletedReports) {
                    mapping.removeOriginalReportById(reportId);
                }
            }
            else {
                irGlobal.defaultErrorFunction("Failed to delete report template", data.message, "");
            }

            if (sucessCallback) {
                sucessCallback(data, e);
            }

            if (loadDrilldown) {
                loadDrilldown();
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to delete report template";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
}